/**
 * ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
 * Bangalore, India. All Rights Reserved.
 */
import {
  PolymerElement,
  html
} from "@polymer/polymer/polymer-element.js";
import {
  mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js";
import '../behaviors/log-out-behaviour.js';
import '../behaviors/mpin-register-behaviour.js';

class changeMpin extends mixinBehaviors([corpBehaviours.logOutBehaviour, corpBehaviours.mpinRegisterBehaviour], PolymerElement) {
  /** Properties definition*/
  static get properties() {
    return {
      errorMessage: {
        type: String,
        notify: true
      },
      myprofilepagenumber: {
        type: Number,
        notify: true,
        observer: 'pageChanged'
      },
      selected: {
        type: Number,
        notify: true
      },
      phone: {
        type: String,
        notify: true,
        observer: 'changeStyle'
      },
      successMsg: {
        type: String,
        notify: true
      },
      mpinAuthList: {
        type: Object,
        notify: true
      },
      showCorrectIcon: {
        type: Boolean,
        value: true,
        notify: true
      },
      newPwd: {
        type: String,
        notify: true,
        value: getLabel('l_NewPassword')
      },
      confirmPwd: {
        type: String,
        notify: true,
        value: getLabel('l_ReEnterPassword')
      },
      newMpinInput: {
        type: String,
        notify: true
      }
    };
  }
  /** HTML template definition*/
  /**
   * Array of strings describing multi-property observer methods and their
   * dependant properties
   */
  static get observers() {
    return [
      'validateMpin(newMpinInput,confirmMpin)'
    ];
  }

  static get template() {
    return html `
        <style include="app-styles">
        .banner-skew[phone] {
          top: 7.5vw;
      }
      .correct-icon {
        --iron-icon-width: 24px;
        --iron-icon-height: 24px;  
      }
 
      
    </style>
    <app-data app-data="{{appData}}"></app-data>
    <oe-ajax id="logoutAjax" method="post" content-type="application/json" body="{{objData}}" on-response="_handleResponse" on-error="_handleError"></oe-ajax>
    
          <div class="mdl-grid">   
                <div class="mdl-cell mdl-cell--12-col">
                    <paper-password-input  id="existing_mpin" required="required" label="Existing MPIN" value={{oldMpinInput}} class="cursor-pointer primary-dark-text-xxl dark-input-style"
                          oncopy="return false" onpaste="return false" maxlength="6" auto-validate></paper-password-input>
                </div>
                <div class="mdl-grid padding-b-zero"></div>
                <div class="mdl-cell">
                  <paper-password-input id="set_mpin" required="required" label="New MPIN" value={{newMpinInput}} class="cursor-pointer secondary-dark-text-xxl dark-input-style"
                             oncopy="return false" onpaste="return false"maxlength="6" auto-validate></paper-password-input>
                </div>
                <div class="mdl-grid padding-b-zero"></div>
                               
                  <div class="mdl-cell">
                          <oe-input id="confirm_mpin" class="" disablecopypaste label="l_confirmPin" auto-validate error-message="m_invalidAccountId"
                                  inputmode="numeric"  maxlength="6" allowed-pattern="[0-9]" value="{{confirmMpin}}">
                                <div slot="suffix" hidden="{{showCorrectIcon}}">
                                    <iron-icon id="correct-tick" class="correct-icon brand-icon" name="confActSucessIcon" icon="icons:check"></iron-icon>
                                </div>
                  </div> 
          </div>
                   
                    
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    
                    <div class="mdl-cell mdl-grid mdl-cell--12-col content-align-center">
                        <paper-button id="prepwdProceed" class="primary-button button-position"  raised on-tap="submitMpinPassword">
                          <oe-i18n-msg msgid="b_Submit"></oe-i18n-msg>
                      </paper-button>                     
                    </div>`;
  }
  pageChanged() {
    if (this.myprofilepagenumber == 8) {
      this.$$('#existing_mpin').$.input.focus()
    }
	
	if(this.myprofilepagenumber == 14){
		 this.oldMpinInput = "";
		this.newMpinInput = "";
		this.confirmMpin = "";
		this.shadowRoot.querySelector("#existing_mpin").shadowRoot.querySelector("paper-input").shadowRoot.querySelector("paper-input-container").childNodes[7].removeAttribute("invalid");
		this.shadowRoot.querySelector("#set_mpin").shadowRoot.querySelector("paper-input").shadowRoot.querySelector("paper-input-container").childNodes[7].removeAttribute("invalid");
		var ExistingmpinField = this.shadowRoot.querySelector("#existing_mpin")
            ExistingmpinField.addEventListener('keyup', function(event) {
                 this.value = this.value.replace(/[^0-9]/g, '');
            }, false);
		var setmpinField = this.shadowRoot.querySelector("#set_mpin")
            setmpinField.addEventListener('keyup', function(event) {
                 this.value = this.value.replace(/[^0-9]/g, '');
            }, false);
	}
  }
  validateMpin(newMpinInput, confirmMpin) {
    if (!_.isEmpty(newMpinInput) && !_.isEmpty(confirmMpin)) {
      if (newMpinInput == confirmMpin) this.showCorrectIcon = false;
      else this.showCorrectIcon = true;
    } else this.showCorrectIcon = true;
  }
  changeStyle() {
    this.updateStyles();
  }
  _toggleVisibilityVal() {
    if (this.$.set_mpin !== undefined && this.$.set_mpin.getAttribute('type') !== undefined) {
      if (this.$.set_mpin.getAttribute('type') === 'password') this.$.set_mpin.setAttribute('type', 'text');
      else if (this.$.set_mpin.getAttribute('type') === 'text') this.$.set_mpin.setAttribute('type', 'password');
    }
  }
  clearFields() {
    this.$.loginnewPass.visible = false;
    this.$.loginconPass.visible = false;
    this.newAccessCode = "";

    if (this.$.loginnewPass != undefined) {
      this.$.loginnewPass.invalid = false;
      this.$.loginconPass.invalid = false;
    }

    this.conAccessCode = "";
    this.goToLoginPage();
  }
  submitMpinPassword() {
    if (!this.oldMpinInput) {
      this.fire("oe-show-error", getLabel('m_enterOldMPIN'));
      return false;
    } else if (!this.newMpinInput) {
      this.fire("oe-show-error", getLabel('m_enterNewMPIN'));
      return false;
    } else if (!this.confirmMpin) {
      this.fire("oe-show-error", getLabel('m_enterConfirmMPIN'));
      return false;
    } else if (this.oldMpinInput == this.newMpinInput) {
      this.fire("oe-show-error", getLabel('m_validateOldnNewMPIN'));
      return false;
    } else if (this.newMpinInput != this.confirmMpin) {
      this.fire("oe-show-error", getLabel('m_validateNewMPIN'));
      return false;
    } else {
      if ("undefined" != typeof MAuth) {
        var changePinArgs = [{
          userID: this.appData.loggedInUserInfo.userId,
          oldPin: this.oldMpinInput,
          newPin: this.newMpinInput
        }];
        var self = this;
        MAuth.active(changePinArgs, "change", function (res) {
          try {
            if (typeof res == "string") {
              res = JSON.parse(res);
            }
            if ("TRUE" == res.changeMPINDone) {
				
				var KeyDataMPIN = {"data1": self.newMpinInput,
                             "data2": "MPIN"} ;
                             KeyDataMPIN = JSON.stringify(KeyDataMPIN);
                             if (channelType.android) {
                                     cordova.plugins.SharedPreferenceHandler.getDataString("my_app", "BiometricEnableStatus" + clientStorage.get(storageType.local, 'username').toUpperCase(),
                                       function (key) {
                                         console.log("Returns key on success " + key);
                                         if (key == 1) {
                                           cordova.plugins.SharedPreferenceHandler.setDataString("SPEED_SECURE_DATA", "SecurePassword" + clientStorage.get(storageType.local, 'username').toUpperCase(), KeyDataMPIN,
                                                                            function (key) {//console.log("Returns key on success " + key);
                                                                            },
                                                                            function (error) {//console.log("Returns error on failure " + error);
                                                                            });
                                         }
                                       },
                                      function (error) {
                                         console.log("Returns error on failure " + error);
                                       });
                                   } else {
                                     cordova.plugins.CDVKeychain.getForKey("BiometricEnableStatus" + clientStorage.get(storageType.local, 'username').toUpperCase(),
                                       function (key) {//console.log("Returns key on success " + key);
                                         if (key == 1) {

                                            cordova.plugins.CDVKeychain.setForKey(clientStorage.get(storageType.local, 'username').toUpperCase(), self.newMpinInput,
                                                                            function (key) {//console.log("Returns key on success " + key);
                                                                            },
                                                                            function (error) {//console.log("Returns error on failure " + error);
                                                                            });
                                         }
                                       },
                                       function (error) {//console.log("Returns error on failure " + error);
                                       });
                                   }
              self.fire('oe-show-success', {
                message: "MPIN changed Successfully",
                forever: true,
                actionName: getLabel('b_OK'),
                callBack: function () {
                  window.oe_navigate_to("/logout");
                }
              });
            } else {
              self.fire('oe-show-error', "Entered invalid credential");
            }
          } catch (error) {
            self.fire('oe-show-error', "Something went wrong");
          }
        }, function (error) {
          self.fire('oe-show-error', "Something went wrong");
        });
      }
    }
  }
}

customElements.define('change-mpin', changeMpin);
